module.exports = __webpack_public_path__ + "img/8group-vr2-icon.5b375461.svg";